import { api } from '@api'

export const handleGetMessageMeta = async () => {
	const { data } = await api().from('message_meta').select('*')

	return data || []
}
